<template>
  <Modal ref="modalRef" class="dialog" v-bind="$attrs" v-on="$listeners">
    <h1 class="dialog-title">
      <slot name="title"></slot>
    </h1>
    <div class="dialog-content">
      <slot name="content"></slot>
    </div>
    <div class="dialog-footer">
      <Button
        v-if="useCancelBtn"
        class="dialog-footer-cancel"
        type="default"
        @click="cancelDialog"
      >
        {{ languages.cancel }}
      </Button>
      <Button class="dialog-footer-confirm" @click="confirmDialog">
        {{ languages.confirm }}
      </Button>
    </div>
  </Modal>
</template>

<script>
import Button from './Button.vue';
import Modal from './Modal.vue';

export default {
  name: 'ConfirmDialog',
  emits: ['cancel', 'confirm'],
  props: {
    useCancelBtn: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    languages() {
      return this.$store.state.languages;
    }
  },
  methods: {
    closeModal() {
      this.$refs?.modalRef?.closeModal();
    },
    cancelDialog() {
      this.$emit('cancel');
      this.closeModal();
    },
    confirmDialog() {
      this.$emit('confirm');
      this.closeModal();
    }
  },
  components: {
    Modal,
    Button
  }
};
</script>

<style lang="scss" scoped>
.dialog {
  &-title {
    margin-top: 6px;
    margin-bottom: 56px;
    font-size: 32px;
  }
  &-content {
    margin-bottom: 80px;
    font-size: 24px;
  }
  &-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 30px;
    &-cancel,
    &-confirm {
      flex: 1;
      height: 100px;
    }
  }
}
</style>
